import * as React from 'react';
import {Mutation} from 'react-apollo';

import type {ExternalService} from 'nutshell-graphql-types';
import type {
    GetSyncStatuses as GetSyncStatusesQuery,
    clearIntegrationOfType as clearIntegrationOfTypeMutation,
    clearIntegrationOfTypeVariables as clearIntegrationOfTypeMutationVariables,
} from 'nutshell-graphql-types';

import CLEAR_INTEGRATION_MUTATION from './graphql/mutations/clear-integration.graphql';
import GET_SYNC_STATUSES_QUERY from './graphql/queries/get-sync-statuses.graphql';

class ClearIntegrationMutation extends Mutation<
    clearIntegrationOfTypeMutation,
    clearIntegrationOfTypeMutationVariables
> {}

type Props = {
    children: (arg1: {
        clearIntegration: (arg1: ExternalService) => Promise<any>;
        isLoading: boolean;
    }) => React.ReactElement;
};

export const ClearIntegration = (props: Props) => (
    <ClearIntegrationMutation mutation={CLEAR_INTEGRATION_MUTATION}>
        {(clearIntegration, {loading: isClearingIntagration}) =>
            props.children({
                clearIntegration: (integrationType: ExternalService) => {
                    return clearIntegration({
                        variables: {externalService: integrationType},
                        update: (cache, mutationResult) => {
                            const result =
                                mutationResult &&
                                mutationResult.data &&
                                mutationResult.data.clearIntegration;
                            if (!result) return;
                            const {taskSync, calendarSync} = result;

                            // Update task query cache
                            const cacheResult: GetSyncStatusesQuery | null | undefined =
                                cache.readQuery({
                                    query: GET_SYNC_STATUSES_QUERY,
                                });
                            if (cacheResult) {
                                cache.writeQuery({
                                    query: GET_SYNC_STATUSES_QUERY,
                                    data: {
                                        loggedInUser: {
                                            ...cacheResult.loggedInUser,
                                            taskSync,
                                            calendarSync,
                                        },
                                    },
                                });
                            }
                        },
                    });
                },
                isLoading: isClearingIntagration,
            })
        }
    </ClearIntegrationMutation>
);
